import { useEffect } from 'react';
import Raven from 'raven-js';
import { registerCustomFunction, unregisterCustomFunction } from 'nudge-client-utils';
import { EMPTY_STATE_FLOW_LOCAL_STORAGE_FLAG } from '../constants/emptyStates';
export const SET_MEETING_EMPTY_STATE_CUSTOM_FUNCTION = 'meetingsAdmin:setMeetingEmptyStateLocalStorage';
export const NudgeCustomFunctionsSetup = () => {
  useEffect(() => {
    // Register function to set local storage flag enabling the meeting empty state flow for the tour's first step
    // https://tools.hubteamqa.com/central-engagement-manager/view/ONBOARDING_TOUR_CREATEANDEXPLOREMEETINGS_3246
    registerCustomFunction(SET_MEETING_EMPTY_STATE_CUSTOM_FUNCTION, () => {
      try {
        window.localStorage.setItem(EMPTY_STATE_FLOW_LOCAL_STORAGE_FLAG, 'true');
      } catch (error) {
        Raven.captureException(error);
      }
    });
    return () => {
      unregisterCustomFunction(SET_MEETING_EMPTY_STATE_CUSTOM_FUNCTION);
    };
  }, []);
  return null;
};